import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {
  Container, Row, Col, Card, CardBody, Spinner, Badge, Button,
} from 'reactstrap'
import moment from 'moment'
import { currencyFormatter } from '../../../utils/currencyFormatter'
import AddContract from '../../../components/Modal/AddContract'
import AddDraftContract from '../../../components/Modal/AddDraftContract'
import DataTable from '../../../components/Template/Table/DataTable'
import Select from '../../../components/Template/Input/Select'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { listProposals, getDraftContracts } from '../../../store/ducks/comercial'
import oikosApi from '../../../services/oikos/index';
import qs from 'qs';
import { c } from 'tar'
import {MaterialReactTable} from 'material-react-table'
import { access } from 'graceful-fs'

const statusCodeMap = {
  'Em contratação': ['UC_IXBSS5', 'C14:UC_3AVN8G'],
  'Em minuta': ['C14:NEW', 'C14:PREPARATION', 'C14:UC_KHSIDR'],
  'Em assinatura': ['C14:PREPAYMENT_INVOIC', 'C14:EXECUTING'],
  'Contratada': ['CONTRATADA']
}

function formatStatus(status) {
  if (['UC_IXBSS5', "C14:UC_3AVN8G"].includes(status)) return <Badge className="badge-soft-warning mr-1">Em contratação</Badge>
  else if (["C14:NEW", "C14:PREPARATION", "C14:UC_KHSIDR"].includes(status)) return <Badge className="badge-soft-info mr-1">Em minuta</Badge>
  else if (["C14:PREPAYMENT_INVOIC", "C14:EXECUTING"].includes(status)) return <Badge className="badge-soft-success mr-1">Em assinatura</Badge>
  else if (["CONTRATADA"].includes(status)) return <Badge className="badge-soft-success mr-1">Contratada</Badge>
  else return <Badge className="badge-soft mr-1">placeholder</Badge>
}

async function fetchAllDeals() {
  let allDeals = [];
  let start = 0;

  do {
    const response = await fetch('https://ecossis.bitrix24.com.br/rest/14/cjj8opek6x5g7s42/crm.deal.list', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ start })
    });

    const data = await response.json();

    const filteredResult = data.result.filter( d => ['UC_IXBSS5', 'C14:UC_3AVN8G', 'C14:NEW', 'C14:PREPARATION', 'C14:UC_KHSIDR', 'C14:PREPAYMENT_INVOIC', 'C14:EXECUTING'].includes(d.STAGE_ID))

    for (const deal of filteredResult) {
      const dealInfo = await fetch(`https://ecossis.bitrix24.com.br/rest/14/cjj8opek6x5g7s42/crm.deal.get/?id=${deal.ID}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })

      const dealData = await dealInfo.json();

      const dealCompany = await fetch(`https://ecossis.bitrix24.com.br/rest/14/cjj8opek6x5g7s42/crm.company.get/?id=${dealData.result.COMPANY_ID}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })

      const dealCompanyData = await dealCompany.json();

      allDeals.push({...dealData.result, companyInfo: {...dealCompanyData.result}});
    }

    start = data.next;
  } while (start !== undefined);

  const contratadas = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'contrato',
    data: {
      contrato_ativo: 1,
    },
    fields: {
      '(SELECT pj_nomefanta FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'pj_nomefanta',
      '(SELECT pj_emailPrin FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'pj_emailPrin',
      '(SELECT pj_telPrin FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'pj_telPrin',
    }
  })}`);

  const contratosComDataDeAssinatura = contratadas.data.filter( c => new Date(c.contrato_dtAssin).getFullYear() === new Date().getFullYear() ).map( c => {return {...c, STAGE_ID: 'CONTRATADA'}})

  allDeals = [...allDeals, ...contratosComDataDeAssinatura]

  console.log('Total deals retrieved:', allDeals);

  return allDeals;
  // You can optionally return or process allDeals here
}

function filteredDeals(deals) {
  const todosDeals = deals.filter(d => [
    'UC_IXBSS5',
    'C14:UC_3AVN8G',
    'C14:NEW',
    'C14:PREPARATION',
    'C14:UC_KHSIDR',
    'C14:PREPAYMENT_INVOIC',
    'C14:EXECUTING',
  ].includes(d.STAGE_ID))
  const emContratacao = todosDeals.filter(d => d.STAGE_ID === 'UC_IXBSS5' || d.STAGE_ID === 'C14:UC_3AVN8G');
  const emMinuta = todosDeals.filter(d => d.STAGE_ID === 'C14:NEW' || d.STAGE_ID === 'C14:PREPARATION' || d.STAGE_ID === 'C14:UC_KHSIDR');
  const emAssinatura = todosDeals.filter(d => d.STAGE_ID === 'C14:PREPAYMENT_INVOIC' || d.STAGE_ID === 'C14:EXECUTING');
  const contratadas = deals.filter(d => d.contrato_id);

  return { allDeals: todosDeals, emMinuta, emAssinatura, emContratacao, contratadas }
}

const columns = [
  {
    accessorKey: 'TITLE',
    header: 'Nome',
    size: 100,
    Cell: ({ cell, row }) => {
      if (!row.original.TITLE) {
        return row.original.contrato_nome
      }
      return row.original.TITLE;
    },
    accessorFn: (row) => {
      return row.TITLE || row.contrato_nome;
    }
  },
  {
    accessorKey: 'OPPORTUNITY',
    header: 'Valor',
    size: 100,
    Cell: ({ cell, row }) => {
      if (!row.original.OPPORTUNITY && row.original.contrato_vlrGlobal) {
        return currencyFormatter.format(row.original.contrato_vlrGlobal)
      } else if (!row.original.OPPORTUNITY) {
        return 'Sem valor';
      } else if (row.original.OPPORTUNITY) {
        return currencyFormatter.format(row.original.OPPORTUNITY);
      }
    },
    accessorFn: (row) => {
      if (!row.OPPORTUNITY) {
        return Number(row.contrato_vlrGlobal);
      }
      return Number(row.OPPORTUNITY)
    }
  },
  {
    accessorKey: 'UF_CRM_1726250379',
    header: 'Data',
    size: 100,
    Cell: ({ cell, row }) => {
      if (row.original.UF_CRM_1726250379 === undefined) {
        return moment(row.original.contrato_dtAssin).format('DD/MM/YYYY');
      } else if (row.original.UF_CRM_1726250379 === "") {
        return 'Sem data'
      }
      return moment(row.original.UF_CRM_1726250379).format('DD/MM/YYYY');
    },
    accessorFn: (row) => {
      if (row.UF_CRM_1726250379 === undefined) {
        return new Date(row.contrato_dtAssin);
      } else if (row.UF_CRM_1726250379 === "") {
        return 'Sem data'
      }
      return new Date(row.UF_CRM_1726250379);
    }
  },
  {
    accessorKey: 'STAGE_ID',
    header: 'Status',
    size: 100,
    Cell: ({ cell, row }) => {
      if (row.original.STAGE_ID) {
        return formatStatus(row.original.STAGE_ID)
      }
    },
  },
]

class Private extends Component {
  constructor(props) {
    super(props)
    this.state = {
      statusFilter: {value: 'Todas', label: 'Todas'},
      dateFilter: null,
      addContractModalIsOpen: false,
      addContractDataDraft: {},

      addDraftContractModalIsOpen: false,
      addDraftContractPreviousData: {},
      allDeals: null,
      filteredDeals: null,
    }
  }

  async componentDidMount() {
    const { listProposals, getDraftContracts } = this.props

    const allDeals = await fetchAllDeals();
    this.setState({filteredDeals: allDeals, allDeals: allDeals})
    listProposals()
    getDraftContracts()
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.statusFilter?.label !== this.state.statusFilter?.label ||
      prevState.dateFilter !== this.state.dateFilter
    ) {
      this.handleFilter();
    }
  }
  /*
  */

  handleStatusChange = (props) => {
    this.setState({ statusFilter: {value: props.label, label: props.label} });
  };

  handleMonthChange = (e) => {
    this.setState({ dateFilter: e.target.value });
  };

  handleFilter() {
    if (this.state.statusFilter.label !== 'Todas') {
      const filtered = this.state.allDeals.filter((deal) => {
        let dealDate = undefined;
        let dealMonth = undefined;
        if (deal.UF_CRM_1726250379) {
          dealDate = new Date(deal.UF_CRM_1726250379);
        } else if (deal.UF_CRM_1726250379 === undefined){
          dealDate = new Date(deal.contrato_dtAssin);
        }

        if (dealDate) {
          dealMonth = String(dealDate.getMonth() + 1).padStart(2, '0');
        }

        //const resolvedStatus = statusCodeMap[deal.STAGE_ID] || 'unknown';
        const resolvedStatus = statusCodeMap[this.state.statusFilter.label] || 'unknown';

        const matchesStatus = resolvedStatus.includes(deal.STAGE_ID);
        const matchesMonth = !this.state.dateFilter || dealMonth === this.state.dateFilter;

        return matchesStatus && matchesMonth;
      });

      console.log(filtered)

      this.setState({filteredDeals: filtered});
    } else {
      const filtered = this.state.allDeals.filter((deal) => {
        let dealDate = undefined;
        let dealMonth = undefined;
        if (deal.UF_CRM_1726250379) {
          dealDate = new Date(deal.UF_CRM_1726250379);
        } else if (deal.UF_CRM_1726250379 === undefined){
          dealDate = new Date(deal.contrato_dtAssin);
        }

        if (dealDate) {
          dealMonth = String(dealDate.getMonth() + 1).padStart(2, '0');
        }

        const matchesMonth = !this.state.dateFilter || dealMonth === this.state.dateFilter;

        return matchesMonth;
      });

      console.log(filtered)

      this.setState({filteredDeals: filtered});
    }
  }

  renderStep = props => {
    const isSelected = props.label === this.state.statusFilter?.label

    return (
      <div
        className="d-flex flex-column flex-grow-1 align-items-center"
        key={props.label}
      >
        <span
          style={{
            fontSize: 12,
            fontWeight: isSelected ? 700 : 500,
            width: 100,
            textAlign: 'center',
            color: isSelected ? 'black' : '#505a62',
            cursor: 'pointer',
          }}
          onClick={(e) => {
            if (props.label !== 'Todas') {
              console.log(props);
              this.handleStatusChange(props)
            } else {
              this.setState({filteredDeals: this.state.allDeals, statusFilter: {value: "Todas", label: "Todas"} })
            }
          }}
        >
          {props.label}
        </span>
        <div
          style={{ width: '100%', height: 30 }}
          className="d-flex flex-row align-items-center"
        >
          <div
            className="d-flex flex-grow-1"
            style={{
              height: 2,
              backgroundColor: '#505a62',
            }}
          />
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: 26,
              height: 26,
              borderRadius: 13,
              border: `2px solid ${isSelected ? 'black' : '#505a62'}`,
              cursor: 'pointer',
            }}
            onClick={(e) => {
            if (props.label !== 'Todas') {
              console.log(props);
              this.handleStatusChange(props)
            } else {
              this.setState({filteredDeals: this.state.allDeals, statusFilter: {value: "Todas", label: "Todas"} })
            }
          }}
          >
            <span
              style={{
                fontWeight: isSelected ? 700 : 500,
                color: isSelected ? 'black' : '#505a62',
                fontSize: 12,
              }}
            >
              {props.count}
            </span>
          </div>
          <div
            className="d-flex flex-grow-1"
            style={{
              height: 2,
              backgroundColor: '#505a62',
            }}
          />
        </div>
        <span
          style={{
            fontSize: 12,
            width: 100,
            textAlign: 'center',
            color: isSelected ? 'black' : '#505a62',
            fontWeight: isSelected ? 700 : 500,
            cursor: 'pointer',
          }}
          onClick={(e) => {
            if (props.label !== 'Todas') {
              console.log(props);
              this.handleStatusChange(props)
            } else {
              this.setState({filteredDeals: this.state.allDeals, statusFilter: {value: "Todas", label: "Todas"} })
            }
          }}
        >
          {props.sum}
        </span>
      </div>
    )
  }

  /*
  renderActionsButton = (proposal) => {
    const status = proposal?.draftContract?.minuta_flowStatus

    switch (status) {
      case 0: return (
        <Button
          disabled
          color="info"
          size="sm"
          outline
          onClick={() => this.setState({
            addDraftContractModalIsOpen: true,
            addDraftContractPreviousData: proposal,
          })}
          title="Aguardando aprovação"
        >
          Minuta em análise
        </Button>
      )

      case 1: return (
        <Button
          color="primary"
          size="sm"
          outline
          onClick={() => this.setState({
            addContractModalIsOpen: true,
            addContractDataDraft: proposal,
          })}
        >
          Cadastrar contrato
        </Button>
      )

      case 2: return (
        <Button
          color="danger"
          size="sm"
          outline
          onClick={() => this.setState({
            addDraftContractModalIsOpen: true,
            addDraftContractPreviousData: proposal,
          })}
          title="Minuta rejeitada"
        >
          Minuta rejeitada
        </Button>
      )

      default: return (
        <Button
          color="primary"
          size="sm"
          outline
          onClick={() => this.setState({
            addDraftContractModalIsOpen: true,
            addDraftContractPreviousData: proposal,
          })}
          title="Cadastrar minuta"
        >
          Cadastrar minuta
        </Button>
      )
    }
  }
  */


  render() {

    const {
      proposals, listProposalsIsLoading,
      draftContracts, getDraftContractsIsLoading,
    } = this.props.comercial

    //const { isManager } = this.props.auth.user

    //if (!isManager) return <Redirect to="/" />

    if (listProposalsIsLoading || getDraftContractsIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    let filteredProposals = []
    let proposalsReduced = []
    if (this.state.allDeals) {
      // Get statistics
      proposalsReduced = [
        {
          label: 'Todas',
          sum: '',
          count: this.state.allDeals ? this.state.allDeals?.length : 'erro',
        },
        {
          label: 'Em contratação',
          sum: currencyFormatter.format(this.state.allDeals
            .reduce((total, current) => {
              if(current.STAGE_ID === 'UC_IXBSS5' || current.STAGE_ID === 'C14:UC_3AVN8G') {
                return total + Number(current.OPPORTUNITY || 0)
              }
              return total;
            }, 0)),
          count: this.state.allDeals ? this.state.allDeals.filter( d => d.STAGE_ID === 'UC_IXBSS5' || d.STAGE_ID === 'C14:UC_3AVN8G').length : 'erro',
        },
        /*
        {
          label: 'Descartado',
          sum: '',
          count: filteredProposals.filter(proposal => proposal.fields.Status0 === 'Descartado').length,
        },
        */
        {
          label: 'Em minuta',
          sum: currencyFormatter.format(this.state.allDeals
          .reduce((total, current) => {
            if(current.STAGE_ID === 'C14:NEW' || current.STAGE_ID === 'C14:PREPARATION' || current.STAGE_ID === 'C14:UC_KHSIDR') {
              return total + Number(current.OPPORTUNITY || 0)
            }
            return total;
          }, 0)),
          count: this.state.allDeals ? this.state.allDeals.filter( d => d.STAGE_ID === 'C14:NEW' || d.STAGE_ID === 'C14:PREPARATION' || d.STAGE_ID === 'C14:UC_KHSIDR' ).length : 'erro',
        },
        {
          label: 'Em assinatura',
          sum: currencyFormatter.format(this.state.allDeals
            .reduce((total, current) => {
              if(current.STAGE_ID === 'C14:PREPAYMENT_INVOIC' || current.STAGE_ID === 'C14:EXECUTING') {
                return total + Number(current.OPPORTUNITY || 0)
              }
              return total;
            }, 0)),
          count: this.state.allDeals ? this.state.allDeals.filter(d => d.STAGE_ID === 'C14:PREPAYMENT_INVOIC' || d.STAGE_ID === 'C14:EXECUTING').length : 'erro',
        },
        {
          label: 'Contratada',
          sum: currencyFormatter.format(this.state.allDeals
            .reduce((total, current) => {
              if (current.contrato_id) {
                return total + Number(current.contrato_vlrGlobal || 0)
              }
              return total;
            }, 0)),
          count: this.state.allDeals ? this.state.allDeals.filter(d => d.contrato_id).length : 'erro',
        },
      ]
      return (
        <div className="page-content">

        {/*
          <AddContract
            isOpen={addContractModalIsOpen}
            type="private"
            addContractDataDraft={addContractDataDraft}
            toggle={() => {
              this.setState({
                addContractModalIsOpen: false,
                addContractDataDraft: {},
              })

              this.componentDidMount()
            }}
          />

          <AddDraftContract
            isOpen={addDraftContractModalIsOpen}
            addDraftContractPreviousData={addDraftContractPreviousData}
            type="private"
            toggle={() => {
              this.setState({
                addDraftContractModalIsOpen: false,
                addDraftContractPreviousData: {},
              })

              this.componentDidMount()
            }}
          />
        */}


          <Container fluid>
            <Breadcrumbs
              title="Dashboard Comercial"
              breadcrumbItems={[]}
            />

            <Row className="mb-3">

              <Col xl={2} lg={3} md={4} sm={4}>
                <Select
                  isClearable
                  placeholder="Período..."
                  options={[
                    {
                      value: '01',
                      label: 'Janeiro',
                    },
                    {
                      value: '02',
                      label: 'Fevereiro',
                    },
                    {
                      value: '03',
                      label: 'Março',
                    },
                    {
                      value: '04',
                      label: 'Abril',
                    },
                    {
                      value: '05',
                      label: 'Maio',
                    },
                    {
                      value: '06',
                      label: 'Junho',
                    },
                    {
                      value: '07',
                      label: 'Julho',
                    },
                    {
                      value: '08',
                      label: 'Agosto',
                    },
                    {
                      value: '09',
                      label: 'Setembro',
                    },
                    {
                      value: '10',
                      label: 'Outubro',
                    },
                    {
                      value: '11',
                      label: 'Novembro',
                    },
                    {
                      value: '12',
                      label: 'Dezembro',
                    },
                  ]}
                  onChange={selected => this.setState({ dateFilter: selected?.value || null })}
                />
              </Col>
            </Row>

            {proposalsReduced && proposalsReduced.length > 0 && (
              <Row className="ml-0 mr-0 mb-4 mt-4">
                {proposalsReduced.map(i => {
                  return ( this.renderStep({ label: i.label, count: i.count, sum: i.sum }))
                })}
              </Row>
            )}

            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <MaterialReactTable
                      columns={columns}
                      data={this.state.filteredDeals}
                      initialState={{
                        density: 'compact',
                        expanded: false, //expand all groups by default
                        pagination: { pageIndex: 0, pageSize: 20 },
                        sorting: [], //sort by state by default
                      }}
                      enableGrouping={false}
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={false}
                      enableTopToolbar={false}
                      enableRowExpansion={true}
                      renderDetailPanel={({ row }) => {
                        if(row.original.TITLE) {
                          return (
                            <div style={{ padding: '1rem' }}>
                              <p><span style={{fontWeight: 'bold'}}>Descrição:</span> {row.original.TITLE || 'Sem descrição'}</p>
                              <p><span style={{fontWeight: 'bold'}}>Objeto:</span> {row.original.UF_CRM_1709295573 || 'Sem objeto'}</p>
                              <p><span style={{fontWeight: 'bold'}}>Data do envio da proposta:</span> {row.original.UF_CRM_1726250379 ? moment(row.original.UF_CRM_1726250379).format('DD/MM/YYYY') : 'Sem data'}</p>
                              <p><a style={{fontWeight: 'bold'}} target='_blank' href={`https://ecossis.bitrix24.com.br/crm/deal/details/${row.original.ID}/`}>Bitrix</a></p>
                            </div>
                          )
                        } else if (row.original.contrato_id) {
                          return (
                            <div style={{ padding: '1rem' }}>
                              <p><span style={{fontWeight: 'bold'}}>Descrição:</span> {row.original.contrato_nome || 'Sem descrição'}</p>
                              <p><span style={{fontWeight: 'bold'}}>Objeto:</span> {row.original.contrato_obj || 'Sem objeto'}</p>
                              <p><span style={{fontWeight: 'bold'}}>Cliente:</span> {row.original.pj_nomefanta || 'Cliente não registrado'}</p>
                              <p><span style={{fontWeight: 'bold'}}>Email do cliente:</span> {row.original.pj_emailPrin || 'Email não registrado'}</p>
                              <p><span style={{fontWeight: 'bold'}}>Telefone do cliente:</span> {row.original.pj_telPrin || 'Telefone não registrado'}</p>
                              <p><span style={{fontWeight: 'bold'}}>Data de assinatura:</span> {row.original.contrato_dtAssin ? moment(row.original.contrato_dtAssin).format('DD/MM/YYYY') : 'Sem data'}</p>
                              <p><a style={{fontWeight: 'bold'}} target='_blank' href={`https://oikos.ecoss.is/oikos-client/comercial/contratos/${row.original.contrato_id}`}>Contrato</a></p>
                            </div>
                          )
                        }
                      }}
                    />
                    {/*
                    <DataTable
                      data={{
                        columns: [
                          {
                            label: 'Nome',
                            field: 'name',
                            sort: 'disabled',
                          },
                          {
                            label: 'Valor',
                            field: 'value',
                            sort: 'disabled',
                          },
                          {
                            label: 'Status',
                            field: 'status',
                            sort: 'disabled',
                          },
                        ],
                        rows:
                        this.state.filteredDeals ? this.state.filteredDeals.map(proposal => ({
                          name: proposal.TITLE ? proposal.TITLE : proposal.contrato_nome,
                          value: proposal.TITLE ? currencyFormatter.format(proposal.OPPORTUNITY) : currencyFormatter.format(proposal.contrato_vlrGlobal),
                          status: this.formatStatus(proposal.STAGE_ID),
                        })) : [],
                      }}
                    />
                    */}
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  comercial: state.comercial,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  listProposals,
  getDraftContracts,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Private)
